<template>
  <v-checkbox
    class="vcita-checkbox"
    hide-details="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-if="$scopedSlots.label" v-slot:label>
      <slot name="label" >
      </slot>
    </template>
  </v-checkbox>
</template>

<script>
  export default {
    name: 'VcitaCheckbox',
      model: {
          prop: 'input-value',
          event: 'change'
      },
  }
</script>

<style lang="scss" scoped>
  .vcita-checkbox {
    font-family: var(--primary-font-family);
    font-size: 15px;
    color: rgba(0, 0, 0, 0.87);
    margin-top: 0;
    padding-top: 0;
    ::v-deep {
      label {
        font-family: var(--primary-font-family);
        font-size: 15px;
        line-height: 1.6;
        color: rgba(0, 0, 0, 0.87);
      }
      .v-input--selection-controls__input {
        height: 1em;
        width: 1em;
        margin-bottom: auto;
        margin-top: 4px;

        .v-input--selection-controls__ripple {
          margin-inline-start: 2px;
        }
      }
      i {
        font-size: 20px;
      }
    }
    &.v-input--is-readonly {
      ::v-deep {
        label {
          color: rgba(0, 0, 0, 0.62);
        }
        .v-input--selection-controls__input {

          i {
            color: rgba(0, 0, 0, 0.07);
            background: rgba(0, 0, 0, 0.07);
          }
        }
      }
    }
  }
</style>
